import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export const Banner3 = ({ b }) => {
    return (
        <Link
            key={b.id}
            to={b?.url??""}
            className="block rounded-lg overflow-hidden shadow relative"
        >
            <div className='absolute top-0 left-0 w-full h-full flex flex-col gap-4 items-center justify-center'>
                <h4 className=''>{b?.title}</h4>
                <p className='font-bold lg:text-2xl'>{b?.describe}</p>
                <button className='bg-[--color-button-3] w-auto px-6 py-2 rounded-full text-white text-sm font-bold 
                    hover:bg-[--color-button-2] hover:text-black transition-all duration-200
                '>{b?.action?.title}</button>
            </div>
            <img
                src={b.image}
                alt={`Banner ${b.id}`}
                className="w-full h-[150px] lg:h-auto object-cover"
            />
        </Link>
    )
}
